import React, { FC } from 'react';
import { useTheme } from '@material-ui/core';
import { styled, Theme } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

export type MessageProps = {
  type?: MessageType;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

type MessageType = 'info' | 'error' | 'warning' | undefined;

const StyledMessage = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.config.defaultBorderRadius,
  padding: '1rem 2rem',
  border: '0.1rem solid',
  fontSize: '1.4rem',
  marginTop: '2rem',
  marginBottom: '2rem',
  display: 'flex',
  gap: '1.6rem',
  alignItems: 'center',
  '& a': {
    fontWeight: 'bold',
    color: 'currentColor',
  },
  '& .title': {
    fontWeight: 'bold',
    marginTop: 0,
    marginBottom: '0.5rem',
  },
  '&.info': {
    backgroundColor: theme.palette.info.light,
    borderColor: theme.palette.info.main,
    color: theme.palette.info.main,
  },
  '&.error': {
    backgroundColor: theme.palette.error.light,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
  },
  '&.warning': {
    backgroundColor: theme.palette.warning.light,
    borderColor: theme.palette.warning.dark,
    color: theme.palette.warning.dark,
  },
}));

const Message: FC<MessageProps> = ({ type = 'info', children, className = '', style }) => {
  const theme = useTheme();

  return (
    <StyledMessage className={`${type} ${className}`} data-testid="dm-message" style={style}>
      <FontAwesomeSpriteIcon
        color={theme.palette[type].main}
        iconSize="xl"
        icon={type === 'error' ? SpriteIconsLight.ERROR : SpriteIconsLight.INFO}
      />
      <div>{children}</div>
    </StyledMessage>
  );
};

export default Message;
